import { render, staticRenderFns } from "./loadingComponent.vue?vue&type=template&id=446e021c&scoped=true"
import script from "./loadingComponent.vue?vue&type=script&lang=js"
export * from "./loadingComponent.vue?vue&type=script&lang=js"
import style0 from "./loadingComponent.vue?vue&type=style&index=0&id=446e021c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446e021c",
  null
  
)

export default component.exports